const cSnaps = document.querySelectorAll('.carousel__snapper, .carousel__navigation');
cSnaps.forEach((cSnap) => {
  cSnap.addEventListener('click', (event) => {
    const $slide = document.querySelector(event.target.getAttribute('href'));
    if (!$slide) return;

    // Stops scrolling to anchor point
    if ($slide.scrollIntoViewIfNeeded) {
      event.preventDefault();
      $slide.scrollIntoViewIfNeeded();
    } else if ($slide.scrollIntoView) {
      event.preventDefault();
      $slide.scrollIntoView();
    }
  });
});